import { Stack, Text } from "office-ui-fabric-react";
import React from "react";
import { childrenGap8 } from "./Constants";

interface ITotalNumbersProps {
    label?: string;
    value: number;
}

const TotalNumbers: React.FC<ITotalNumbersProps> = ({ label, value }) => {
    return (
        <React.Fragment>
            {value > 0 && (
                <Stack horizontal tokens={childrenGap8}>
                    <Stack.Item>
                        <Text className="total-numbers-text-label">{label || "Total No of Items:"}</Text>
                    </Stack.Item>
                    <Stack.Item>
                        <Text className="total-numbers-text-value">{value}</Text>
                    </Stack.Item>
                </Stack>
            )}
        </React.Fragment>
    );
};

export default TotalNumbers;